import { Component, HostListener, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { interval } from 'rxjs';
import { ApiservicesService } from './apiservices.service';
import { SidebarProfileComponent } from '../app/components/sidebar-profile/sidebar-profile.component';

import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { AngularPlugin } from '@microsoft/applicationinsights-angularplugin-js';
import { EncryptdecryptService } from './services/encryptdecrypt.service';
import { OAuthService } from './services/oauth.service';
import { APP_CONFIG, AppConfig } from './app-config';

@Component({
  providers: [SidebarProfileComponent],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'taef';

  userActivity:any;
  userInactive: Subject<any> = new Subject();
  FirmIDChange: any = "";
  LoaderStatus: boolean = true;
  RegisterAgentOnly: boolean = false;
  sub: any = "";
  refresh: any = "";
  oauhtInd = true;

  constructor(public router: Router, private apiService: ApiservicesService, 
    private profile: SidebarProfileComponent, 
    private encryptDecryptService: EncryptdecryptService,
    private oauth:OAuthService,
    @Inject(APP_CONFIG) private config: AppConfig // <-- Inject config
  ) {
    var angularPlugin = new AngularPlugin();
    //const appInsights = new ApplicationInsights({
    //  config: {
    //    instrumentationKey: '4181b829-b051-4553-b559-fd30074ae05b',
    //    extensions: [angularPlugin],
    //    extensionConfig: {
    //      [angularPlugin.identifier]: { router: this.router }
    //    }
    //  }
    //});
    //appInsights.loadAppInsights();
  }

  async ngOnInit(): Promise<void> {

    this.oauhtInd = false
    if(sessionStorage.getItem('access_token_oauth') == null)
    {
      this.oauhtInd = true
      const urlParams = new URLSearchParams(window.location.search);
      const encParamTax = urlParams.get('ParamTax');
      const langTax = urlParams.get('lang');
      const token = urlParams.get('token');

      if (encParamTax != null && langTax != null && token != null) {
        sessionStorage.setItem('ParamTax',encParamTax)
        sessionStorage.setItem('lang', langTax)
        sessionStorage.setItem('token', token)
        sessionStorage.removeItem('pkce_code_verifier')
      }

      
      const cv =  sessionStorage.getItem('pkce_code_verifier');

      if(cv == null)
      {
        this.oauth.loginWithPKCE(); 
      }
    }
    else
    {
      this.setTimeout1();
      this.userInactive.subscribe(result => {
       //console.log('user has been inactive for 3s');
      });

      const MyTaxAddress = this.config.MyTaxAddress; // <-- Use config value
      const urlParams = new URLSearchParams(window.location.search);
      const encParamTax = urlParams.get('ParamTax');
      const token = urlParams.get('token');
      //console.log('ParamTax: ' + encParamTax);
      if ((encParamTax === null || encParamTax === "") && (token === null || token === "")) {

        if (sessionStorage.getItem('Register') !== null) {
          sessionStorage.removeItem('Register');
          document.location.href = MyTaxAddress;
        } else if (sessionStorage.getItem('FirmID') === null || sessionStorage.getItem('StaffIDNo') === null) {
          document.location.href = MyTaxAddress;
        } else {
          const resultWithoutParams = await this.apiService.RequestToken();
          if (resultWithoutParams.body.IdNo != this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffIDNo') || '')) {
            alert("Error01: Please re-login from mytax");
            document.location.href = MyTaxAddress;
          } else {
            sessionStorage.removeItem('JWTToken');
            sessionStorage.setItem('JWTToken', this.encryptDecryptService.encrypt(resultWithoutParams.headers.get('Taefauth') || ''));
          }
        }
      } else {
        let language: string = urlParams.get('lang')!; 
        const resultTimeInterval = await this.apiService.RequestToken();
        const resultEncrypt = await this.apiService.GetEncryptDecrypt("202", encParamTax);
        //console.log('Decrypted ParamTax: ' + resultEncrypt);
        let splitted = resultEncrypt.split("|");
        sessionStorage.removeItem('StaffIDType');
        sessionStorage.removeItem('StaffIDNo');
        sessionStorage.removeItem('FirmID');
        sessionStorage.removeItem('StaffID');
        sessionStorage.removeItem('Register');
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('Language');
        sessionStorage.setItem('StaffIDNo', this.encryptDecryptService.encrypt(splitted[0]));
        sessionStorage.setItem('StaffIDType', this.encryptDecryptService.encrypt(splitted[1]));
        sessionStorage.setItem('FirmID', this.encryptDecryptService.encrypt(splitted[2]));
        sessionStorage.setItem('token', token);
        sessionStorage.setItem('Language', language);
        if (splitted.length > 3) {
          if (splitted[3] !== "REG") {
            alert("Error02: Please re-login from mytax");
            document.location.href = MyTaxAddress;
          }
          this.RegisterAgentOnly = true;
          sessionStorage.setItem('Register', this.encryptDecryptService.encrypt(splitted[3]));
          //alert("")
        }

        const resultFirstLogin = await this.apiService.RequestToken();
        sessionStorage.setItem('JWTToken', this.encryptDecryptService.encrypt(resultFirstLogin.headers.get('Taefauth') || ''));
      }

      this.refresh = interval(this.config.refreshIntervalMs).subscribe(async () => {
        const resultTimeRefresh = await this.oauth.refreshAccessToken();
      });

      this.sub = interval(10000).subscribe(async x => {
        const resultTimeInterval = await this.apiService.RequestToken();
        
        
        if (resultTimeInterval.body.Access == 1) {
          if (resultTimeInterval.body.IdNo != this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffIDNo') || '')) {
           //console.log('IDNo mismatch - logging out: '+ resultTimeInterval.body.IdNo + ' - ' + this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffIDNo') || '')  );
            alert("Error03: Please re-login from mytax");
            document.location.href = MyTaxAddress;
          } else {
            sessionStorage.removeItem('JWTToken');
            sessionStorage.setItem('JWTToken', this.encryptDecryptService.encrypt(resultTimeInterval.headers.get('Taefauth') || ''));
          }
        } else {
          alert("Please login");
          document.location.href = MyTaxAddress;
        }
      });

      // ENABLE WHEN NEED TO DEBUG WITH NG SERVE TEST ONLY
      // const resultTimeInterval = await this.apiService.RequestToken();
      // sessionStorage.setItem('StaffIDType', this.encryptDecryptService.encrypt('1')); //admin
      // sessionStorage.setItem('StaffIDNo', this.encryptDecryptService.encrypt('630303025763')); //admin & agent
      // sessionStorage.setItem('FirmID', this.encryptDecryptService.encrypt('54595'));
      // END NG SERVE TEST

      await this.profile.GetFirm();
      await this.profile.GetAgentDetails(this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffIDNo') || ''), this.encryptDecryptService.decrypt(sessionStorage.getItem('FirmID') || ''));
      this.LoaderStatus = false;
    }
    
  }

  setTimeout1() {
    this.userActivity = setTimeout(() => this.userInactive.next(undefined), 3000);
  }

  @HostListener('window:mousemove') refreshUserState() {
    clearTimeout(this.userActivity);
    this.setTimeout1();
  }

  @HostListener('window:keydown') refreshUserStateKey() {
    clearTimeout(this.userActivity);
    this.setTimeout1();
  }

  async ChangeFirm(FirmID: any) {
    this.FirmIDChange = FirmID;
  }
}
